import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

interface UseGetPropertyOwnerByIdProps {
  id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOwnerById = async (id: string, communityId: string) =>
  await axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${id}`);

const useGetPropertyOwnerByIdV2 = ({
  id,
  communityId,
  queryParams,
}: UseGetPropertyOwnerByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["propertyOwner", id],
    queryFn: () => getPropertyOwnerById(id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!id,
    ...queryParams,
  });
};

export default useGetPropertyOwnerByIdV2;
